import React, { useState } from 'react';
import Tooltip from '../Tooltip';
import Icon from '../Icon';

// The two movable sections of the annotate page, top to bottom.
export const SECTIONS = { add: 'Add at this moment', list: 'Subtitles & annotations' };
const DEFAULT_ORDER = ['add', 'list'];
const STORAGE_KEY = 'hoja_annotate_order';

function load() {
  try {
    const saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    if (Array.isArray(saved) && saved.length === DEFAULT_ORDER.length
      && DEFAULT_ORDER.every((k) => saved.includes(k))) return saved;
  } catch (e) { /* no saved order */ }
  return DEFAULT_ORDER;
}

/**
 * The order of the annotate page's movable sections (Add panel, Subtitles &
 * annotations), remembered in the teacher's browser. Returns [order,
 * move(key, -1 | 1)].
 */
export function useSectionOrder() {
  const [order, setOrder] = useState(load);
  const move = (key, delta) => setOrder((prev) => {
    const i = prev.indexOf(key);
    const j = i + delta;
    if (i < 0 || j < 0 || j >= prev.length) return prev;
    const next = [...prev];
    [next[i], next[j]] = [next[j], next[i]];
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch (e) { /* keep for this visit */ }
    return next;
  });
  return [order, move];
}

/** The up / down arrows of a section: only the directions it can move. */
export function MoveSection({ sectionKey, order, move }) {
  const i = order.indexOf(sectionKey);
  const name = SECTIONS[sectionKey];
  return (
    <span className="section-move">
      {i > 0 && (
        <Tooltip label={`Move ${name} up`}>
          <button type="button" className="icon-btn icon-btn--sm" onClick={() => move(sectionKey, -1)}
            aria-label={`Move ${name} up`}><Icon name="arrow-up" size={15} /></button>
        </Tooltip>
      )}
      {i < order.length - 1 && (
        <Tooltip label={`Move ${name} down`}>
          <button type="button" className="icon-btn icon-btn--sm" onClick={() => move(sectionKey, 1)}
            aria-label={`Move ${name} down`}><Icon name="arrow-down" size={15} /></button>
        </Tooltip>
      )}
    </span>
  );
}
